export default "__VITE_ASSET__CLpjSUwK__"